module.exports = __webpack_public_path__ + "static/training2-e42f5ea8c57ac062617c752ea32d7313.jpeg";